import {checkProductInText, sanitizeText} from "../../libs/utils";

interface GdnProduct {
  value: string;
  label: string;
  shortLabel?: string;
  hideProductName?: boolean;
}

/** Resolve editable GDN product text without replacing an explicit empty value. */
export function resolveGdnProductName(
  productNames: Record<string, string>,
  id: string,
  product: GdnProduct
): string {
  if (Object.hasOwn(productNames, id)) return productNames[id];
  if (Object.hasOwn(productNames, "main")) return productNames.main;

  // These wordmarks already contain the complete product name. Other products
  // need a suffix to identify the product next to their shared family logo.
  if (product.hideProductName) return "";
  return product.shortLabel || product.label;
}

/** Check whether the GDN body already identifies the product shown in the header. */
export function shouldHideGdnProductName(
  productName: string,
  productLabel: string,
  bodyTexts: ReadonlyArray<string | null | undefined>
): boolean {
  const candidateNames = [...new Set([sanitizeText(productName), productLabel].filter(Boolean))];
  return bodyTexts.some((text) =>
    candidateNames.some((candidateName) => checkProductInText(candidateName, text))
  );
}
